export default __webpack_public_path__ + "static/media/result2.a8b01c9c.jpg";